import React from "react";
import { Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PaymentStatusHook from "../../hook/user/PaymentStatusHook";

const PaymentStatus = () => {
    const { t } = useTranslation()
    const [responseObject,hyperPayLoading,isLoading] = PaymentStatusHook();
    // if(isLoading && responseObject.ResponseCode) return <h1>loading</h1>;
     if(!responseObject.ResponseCode) return <Spinner />;
    //  console.log('responseObject');
    // console.log(responseObject);
    // console.log(responseObject.ResponseCode);
    
    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-5">
                    <div  className={responseObject.ResponseCode === '000' ? '_success message-box' : '_success _failed message-box'}>
                        <i className="fa fa-check-circle" aria-hidden="true"></i>
                        <h2> {responseObject.ResponseCode === '000' ? t("Your payment was successful") : t("Your payment failed")} </h2>
                        {
                            responseObject.ResponseCode === '000' ? (<p>{t("Thank you for your payment. we will be in contact with more details shortly")}  </p>) : <p> {t("Try again later")}  </p>
                        }
                    </div>
                </div>
            </div>
            <hr />
        </div>
    )
};

export default PaymentStatus;
